var ProfileInfoView = require('../../../shared/app/views/components/profile-info.js');
var RegistrationClientModel = require('../../../models/client');

var ClientFormView = Backbone.Epoxy.View.extend({
  template: 'start-wait-list.clientForm',
  bindings: 'data-bind-client',

  events: {
    'click .sign-out-link' : 'signOut',
    'click .login-link' : 'toggleLogin'
  },

  initialize: function(options) {
    this.model = bookedby.app.getCurrentClient();
    this.showLogin = true;
    this.model.set('validateOnlyRequiredPassword', true);
    this.registrationModel = new RegistrationClientModel();
  },

  signOut: function() {
    var options = {
      message: 'Are you sure you want to sign out?',
      cancelLabel: 'Go Back',
      confirmLabel: 'Sign out',
      showCancelLabel: true
    };

    bookedby.app.confirmForm.show(_.bind(function() {
      global.bookedby.helpers.confirmLogoutEvent(false);
      bookedby.app.logOut();
      //this.render();
      //this.toggleFocus();
    }, this), function() {}, options);
  },

  serialize: function() {
    return {
      client: this.model.attributes,
      showLogin: this.showLogin
    };
  },

  toggleLogin: function() {
    this.showLogin = !this.showLogin;
    this.model.set('password', '');
    this.model.set('skipPasswordValidation', true);
    this.model.set('validateOnlyRequiredPassword', false);
    if (this.showLogin) {
      this.model.set('validateOnlyRequiredPassword', true);
    }
    this.render();
  },

  beforeRender: function() {
    this.setView('.profile-info-registration-area', new ProfileInfoView({
      model: this.registrationModel,
      showPasswordFields: false
    }));
  },

  afterRender: function() {
    this.applyBindings();
    this.model.set('validationSuspended', true);

    this.trigger('renderingForm');
  },

  cleanup: function() {
    this.removeBindings();
  },

  setFocus: function() {
    $('.js-main-client-name').focus();
  }
});

module.exports = ClientFormView;
